import { competenciaMesAnterior, dateParaCompetencia, subtrairCompetencia } from "utils/converter-competencia";
export class RelatorioSearchPropsModel {
    constructor(
        public anoMesInicial: number = subtrairCompetencia(competenciaMesAnterior(), 2),
        public anoMesFinal: number = dateParaCompetencia(new Date()),
        public revendaId: string = '',
        public gerenteId: string = '',
    ) { }
}